import { useState } from "react";

import AuthenticationForm from "components/Authentication/AuthenticationForm";

import {
  login,
  organisationAPI,
  // createStripeSetupSession,
} from "api/Accounts/AccountsAPI";

export default function Login() {
  const [error, setError] = useState<Record<string, string> | null>(
    null
  );

  async function handleLogin(values: Record<string, any>) {
    try {
      setError(null);

      const loginResult = await login(
        values.username,
        values.password
      );

      console.log("Login result:", loginResult);

      if (loginResult?.account_type_missing) {
        setError({
          _form:
            "Login succeeded, but we could not determine your account type. Please contact support.",
        });

        return;
      }

      /*
       * login() is redirecting the browser to the correct subdomain.
       *
       * Authentication tokens are not shared between subdomains, so the
       * user will need to log in again after arriving there.
       */
      if (loginResult?.redirected) {
        return;
      }

      /*
       * At this point:
       *
       * 1. Login succeeded.
       * 2. Access and refresh tokens were stored.
       * 3. The user is already on the correct domain.
       */
      const organisation =
        await organisationAPI.getByLoggedInUser();

      console.log(
        "Organisation details:",
        organisation
      );

      if (!organisation) {
        setError({
          _form:
            "Login succeeded, but we could not load your organisation details. Please try again.",
        });

        return;
      }

      /*
       * Stripe payment-method collection is temporarily disabled.
       *
       * if (!organisation.payment_method_collected) {
       *   const session =
       *     await createStripeSetupSession(
       *       organisation.id
       *     );
       *
       *   console.log(
       *     "Stripe setup session:",
       *     session
       *   );
       *
       *   if (!session?.url) {
       *     setError({
       *       _form:
       *         "Login succeeded, but we could not start the billing setup. Please try again.",
       *     });
       *
       *     return;
       *   }
       *
       *   window.location.assign(session.url);
       *   return;
       * }
       */

      /*
       * Use a full browser navigation instead of React Router's navigate().
       *
       * setAuthTokens() changes localStorage, but that does not necessarily
       * update authentication state already held by React context or a route
       * guard.
       *
       * Reloading the app allows the auth provider/private route to initialise
       * again and detect the newly stored access token.
       */
      window.location.replace("/campaigns/");
    } catch (err: any) {
      console.error(
        "Login or organisation check failed:",
        err
      );

      const backendMessage =
        err?.response?.data?.detail ||
        err?.response?.data?.message;

      setError({
        _form:
          backendMessage ||
          "We could not complete the login or load your organisation details. Please try again.",
      });
    }
  }

  return (
    <AuthenticationForm
      title="Login to Your Account"
      submitLabel="Login"
      error={error}
      fields={[
        {
          name: "username",
          label: "Username",
          required: true,
        },
        {
          name: "password",
          label: "Password",
          type: "password",
          required: true,
        },
      ]}
      onSubmit={handleLogin}
    />
  );
}

